import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { notification } from 'antd';

// components
import { RedCrossActivities } from './red-cross-activities';
import { PopularPosts } from './popular-posts';
import { NewPosts } from './new-posts';
import { GroupsActivities } from './groups-activity';
import { TopGroups } from './top-groups';

export function ActivitiesRoute(): JSX.Element {
	const [showError, setShowError] = useState<boolean>(false);

	useEffect(() => {
		if (showError === true) {
			notification.error({ message: 'Netværks fejl', onClose: () => setShowError(false) });
		}
	}, [showError]);

	return (
		<Container className="dashboard-container">
			<NewPosts setShowError={setShowError} />
			<RedCrossActivities setShowError={setShowError} />
			<GroupsActivities setShowError={setShowError} />
			<PopularPosts setShowError={setShowError} />
			<TopGroups />
		</Container>
	);
}

const Container = styled.main`
	padding: 2em;
	background-color: #1a202c;

	display: grid;
	gap: 4em;

	grid-template-columns: repeat(2, 1fr);
	grid-template-areas:
		'popular-posts top-groups'
		'popular-posts top-groups'
		'new-posts group-activities'
		'new-posts red-cross-activities';

	@media (max-width: 1024px) {
		grid-template-columns: repeat(1, 1fr);
		grid-template-areas:
			'new-posts'
			'popular-posts'
			'active-users'
			'red-cross-activities'
			'group-activities';
	}

	.new-posts-panel {
		grid-area: new-posts;
	}

	.active-users-panel {
		grid-area: active-users;
	}

	.popular-posts-panel {
		grid-area: popular-posts;
	}

	.red-cross-activities-panel {
		grid-area: red-cross-activities;
		margin-top: 40px;
	}

	.group-activities-panel {
		grid-area: group-activities;
	}

	.panel-container {
		h2 {
			text-align: center;
			color: #9ca3af;
		}
	}

	.activities-img-reload {
		height: 4vw;
		width: 4vw;
		margin: auto;
		border-radius: 50%;
		object-fit: cover;
	}

	.panel-data {
		background-color: #1f2937;
		box-shadow: #00000020 0px 2px 8px 0px;
		border-radius: 0.5em;
	}

	.ant-table {
		font-size: 1.3em;
	}

	.ant-table-thead th {
		background-color: #1f2937;
		color: #9ca3af;
	}
	.ant-table-tbody td {
		background-color: #1f2937f4;
		color: #ffffff;
	}

	&& tbody > tr:hover > td {
		background: #9ca3af;
		color: black;
	}
`;
